export default __webpack_public_path__ + "static/media/perpertualsuccour.b8509d9a.jpg";